//提前加载图片
const preloadImages = () => {
    for(let i=1;i<26;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ng_box8_${i}.avif?v=1751854979`;
    }
    for(let i=1;i<36;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ng_box9_${i}.avif?v=1751872840`;
    }
    
};
preloadImages()

setTimeout(() => {
    for(let i=1;i<27;i++){
        const img = new Image();
        img.src = `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ng_box10_${i}.avif?v=1751882397`;
    }
}, 3000);


if(window.innerWidth>750){
    var wFlag = true,box8S=1.5,box8X=0,box8Y='22rem',box9S=12000,box9P=5
}else{
    wFlag = false,box8S=1.2,box8X='2rem',box8Y='18rem',box9S=8000,box9P=1.5
}

function showUp(dom){
    gsap.from(dom,{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:dom,
            start:'top bottom-=20%',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })
}

$(()=>{
    setTimeout(() => {
        $('.box1_title').addClass('showup')
    }, 200);

    ScrollTrigger.create({
        trigger:'.box1_1',
        start:'top top+=30%',
        end:'+=0%',
        // markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            if(index>50){
                $(`.box1_1 div`).addClass('box1_active');
            }else{
                $('.box1_1 div').removeClass('box1_active');
            }
        }
    })

    // showUp('.box2_title')

    showUp('.box3_title')

    ScrollTrigger.create({
        trigger:'.box3_items',
        start:'top bottom-=20%',
        end:'+=40%',
        scrub:1,
        // markers:true,
        animation:gsap.timeline().to('.box3_items div',{xPercent:0,x:0,opacity:1})
    })

    showUp('.box4_title')
    
    var nexlimN1 = 150,ng_flag=true,flag_ng;
    function startNG(){
        flag_ng =  setInterval(num,20)
    }
    function num(){
        nexlimN1++;
        $(`.box4_info div span`).text(`${nexlimN1}%`)
        if(nexlimN1 > 199){
            clearInterval(flag_ng);
        }
    }

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box4_1',
            start:'top top+=4%',
            end:'+=40%',
            scrub:1,
            // markers:true,
            animation:gsap.timeline()
                .from('.box4_title',{y:'-50%',scale:1.8,top:'50%'},'-=50%')
                .from('.box4_items',{opacity:0,y:'2rem'},'-=50%')
        })
    
        ScrollTrigger.create({
            trigger:'.box4_1',
            start:'top+=60% top+=4%',
            end:'+=60%',
            scrub:1,
            //markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                if(index>80){
                    // 执行一次
                    if(ng_flag){
                        startNG()
                        ng_flag=false;
                    }
                }
                if(index<10){
                    // 重置
                    ng_flag=true,nexlimN1 = 150
                }
            },
            animation:gsap.timeline()
                .to('.box4_1',{opacity:0})
                .to('.box4_2',{background:'#ebf8ff',scale:1},'-=50%')
                .from('.box4_img',{x:'10rem',opacity:0})
                .from('.box4_title2',{y:'2rem',opacity:0},'-=20%')
                .from('.box4_info',{y:'2rem',opacity:0},'-=20%')
        })
    
        ScrollTrigger.create({
            trigger:'.box4',
            start:'top top+=4%',
            end:'+=140%',
            pin:true
            // markers:true
        })
    }else{
        showUp('.box4_title2')

        ScrollTrigger.create({
            trigger:'.box4_info',
            start:'top bottom-=20%',
            end:'+=10%',
            //markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                if(index>20){
                    // 执行一次
                    if(ng_flag){
                        startNG()
                        ng_flag=false;
                    }
                }
                if(index<10){
                    // 重置
                    //ng_flag=true,nexlimN1 = 150
                }
            },
        })
    }
    showUp('.box5_title')

    ScrollTrigger.create({
        trigger:'.box5_img',
        start:'top center',
        end:'+=0%',
        //markers:true,
        toggleActions:'play none none reverse',
        animation:gsap.timeline().from('.box5_img img:nth-child(2)',{scale:0,duration:1})
    })

    if(wFlag){
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top+=10% top+=6%',
            end:'+=50%',
            scrub:1,
            //markers:true,
            animation:gsap.timeline()
                .to('.box5_1',{opacity:0})
                .to('.box5_imgM',{x:'18rem',y:'7rem',scale:1.6},'-=50%')
                .from('.box5_2',{opacity:0},'-=50%')
        })
    
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top+=120% top+=6%',
            end:'+=20%',
            //markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                if(index>50){
                    $('.box5_item2').addClass('fadeIn')
                    $('.box5_left2').addClass('box5_active')
                    // $('.box5_left2').css({background:'linear-gradient(170deg,black 10%,#dc0000 80%)'})
                    $('.box5_left2 .box5_text1 div span').text('BOOST')
                    $('.box5_left2 .box5_info p:nth-child(1) span').text('80')
                    $('.box5_left2 .box5_info p:nth-child(2) span').text('20')
                    $('.box5_left2 .box5_num span').text('20')
                }else{
                    $('.box5_item2').removeClass('fadeIn')
                    $('.box5_left2').removeClass('box5_active')
                    // $('.box5_left2').css({background:'linear-gradient(170deg,#85f2d3 -8%,#0e9ff9 50%)'})
                    $('.box5_left2 .box5_text1 div span').text('ECO')
                    $('.box5_left2 .box5_info p:nth-child(1) span').text('120')
                    $('.box5_left2 .box5_info p:nth-child(2) span').text('30')
                    $('.box5_left2 .box5_num span').text('30')
                }
            }
        })
    
        ScrollTrigger.create({
            trigger:'.box5',
            start:'top top+=15%',
            end:'+=160%',
            pin:true,
            //markers:true,
        })
    }else{
        showUp('.box5_title2')
    
        ScrollTrigger.create({
            trigger:'.box5_2',
            start:'top top+=8%',
            end:'+=30%',
            pin:true,
            //markers:true,
            onUpdate:(self)=>{
                let index = Math.floor(self.progress * 100);
                if(index>40){
                    $('.box5_left2').addClass('box5_active')
                    $('.box5_left2 .box5_text1 div span').text('BOOST')
                    $('.box5_left2 .box5_info p:nth-child(1) span').text('80')
                    $('.box5_left2 .box5_info p:nth-child(2) span').text('20')
                    $('.box5_left2 .box5_num span').text('20')
                }else{
                    $('.box5_left2').removeClass('box5_active')
                    $('.box5_left2 .box5_text1 div span').text('ECO')
                    $('.box5_left2 .box5_info p:nth-child(1) span').text('120')
                    $('.box5_left2 .box5_info p:nth-child(2) span').text('30')
                    $('.box5_left2 .box5_num span').text('30')
                }
            }
        })
    }

    showUp('.box6_title')
    
    var nexlimN2 = 170,nexlimN3 = 10,nexlimN4 = 0,ng_flag2=true,flag_ng2;
    function startNG2(){
        flag_ng2 =  setInterval(num2,30)
    }
    function num2(){
        nexlimN2++;
        nexlimN3++;
        nexlimN4++;
        $(`.box6_item div:nth-child(1) p span:nth-child(1)`).text(`${nexlimN2}%`)
        $(`.box6_items .box6_item:nth-child(1) div:nth-child(1) p span:nth-child(2)`).text(`${nexlimN3}W`)
        $(`.box6_items .box6_item:nth-child(2) div:nth-child(1) p span:nth-child(2)`).text(`${nexlimN4}`)
        if(nexlimN2 > 199){
            clearInterval(flag_ng2);
        }
    }
    
    ScrollTrigger.create({
        trigger:'.box6_items',
        start:'top center+=10%',
        end:'+=0%',
        //markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            $('.box6_item div:nth-child(1) p').toggleClass('showup',index>20)
            if(index>20){
                // 执行一次
                if(ng_flag2){
                    startNG2()
                    ng_flag2=false;
                }
            }
            if(index<10){
                // 重置
                ng_flag2=true,nexlimN2 = 170,nexlimN3 = 10,nexlimN4 = 0
            }
        }
    })

    $('.box7_btn div').click(function(){
        var index = $(this).index()
        $(this).css({color:'white'}).siblings().css({color:'black'})

        if(index==0){
            $('.box7_btn span').css({transform:'translate(0,-50%)'})
            $('.box7_icon1').css({transform:'translate(-50%)'})
            setTimeout(() => {
                $('.box7_img div').css({animation:'box7_active1 1s'})
                //复原
                $('.box7_img div img').css({transform:'rotate(331deg) translate(0, 3rem)',transition:'all 0s'})
            }, 500);
        }else{
            $('.box7_btn span').css({transform:'translate(100%,-50%)'})
            $('.box7_icon1').css({transform:'translate(-50%,-50%)'})
            setTimeout(() => {
                $('.box7_img div img').css({transform:'rotate(331deg) translate(0, 50rem)',transition:'all 1.5s'})
                $('.box7_img div').css({animation:'none'})
            }, 500);
        }
    })

    showUp('.box7_title')
    
    ScrollTrigger.create({
        trigger:'.box8',
        start:'top top+=4%',
        end:'+=60%',
        //markers:true,
        scrub:1,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 24);
            $('.box8_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ng_box8_${index+1}.avif?v=1751854979`)
        },
        animation:gsap.timeline()
            .from('.box8_info',{opacity:0,y:'2rem'},'-=20%')
            .from('.box8_btn',{opacity:0,y:'2rem'},'-=20%')
    })
    
    ScrollTrigger.create({
        trigger:'.box8',
        start:'top top+=4%',
        end:'+=70%',
        pin:true,
    })

    gsap.from('.box8t_show',{
        y:'2rem',opacity:0,ease:'none',duration:0.5,
        scrollTrigger:{
            trigger:'.box8t_show',
            start:'top center',
            end:'+=0',
            toggleActions:'play none none reverse',
        }
    })

    $('.box8_btn div').click(function(){
        var index = $(this).index()
        if(index==0){
            $('.box8_btn span').css({transform:'translate(0,-50%)'})
        }else if(index==1){
            $('.box8_btn span').css({transform:'translate(100%,-50%)'})
        }else if(index==2){
            $('.box8_btn span').css({transform:'translate(200%,-50%)'})
        }
        $(this).css({color:'white'}).siblings().css({color:'black'})

        $('.box8_info div p:last-child c').hide()
        $(`.box8_info div p:last-child c:nth-child(${index+1})`).show()
    })

    showUp('.box9_title')

    ScrollTrigger.create({
        trigger:'.box9',
        start:'top-=40% top+=8%',
        end:'+=60%',
        //markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 31);
            $('.box9_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ng_box9_${index+1}.avif?v=1751872840`)
            $('.box9_items1').toggleClass('showup',index>20)
        }
    })

    ScrollTrigger.create({
        trigger:'.box9',
        start:'top+=30% top+=8%',
        end:'+=60%',
        //markers:true,
        scrub:1,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 100);
            $('.box9_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ng_box9_32.avif?v=1751872840`)
            for(let i=1;i<4;i++){
                if(index>(i-1)*30){
                    $(`.box9_icon img:nth-child(${i})`).css({opacity:1}).siblings().css({opacity:0});
                    $(`.box9_items1 div:nth-child(${i})`).css({scale:1.15}).siblings().css({scale:1});
                }
            }
            if(index<2 || index>98){
                $('.box9_icon img').css({opacity:0});
                $('.box9_items1 div').css({scale:1});
            }
        }
    })

    ScrollTrigger.create({
        trigger:'.box9',
        start:'top+=100% top+=8%',
        end:'+=40%',
        //markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 5);
            if(index<3){
                $('.box9_img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ng_box9_${index+33}.avif?v=1751872840`)
            }
            $('.box9_items1').toggleClass('opacity0',index>0)
            $('.box9_items2').toggleClass('showup',index>0)
            $('.box9_title div').toggleClass('opacity0',index>0)

            if(index>0){
                $('.box9_title span:nth-child(2)').addClass('active_color')
                $('.box9_title span:nth-child(1)').removeClass('active_color')
            }else{
                $('.box9_title span:nth-child(1)').addClass('active_color')
                $('.box9_title span:nth-child(2)').removeClass('active_color')
            }
        }
    })
    
    ScrollTrigger.create({
        trigger:'.box9',
        start:'top top+=8%',
        end:'+=150%',
        pin:true,
    })

    showUp('.box10_title')

    showUp('.box10_info')

    ScrollTrigger.create({
        trigger:'.box10',
        start:'top+=10% top+=6%',
        end:'+=40%',
        scrub:1,
        //markers:true,
        animation:gsap.timeline()
            .to('.box10_items1',{opacity:0})
            .to('.box10_items2',{opacity:1})
    })

    ScrollTrigger.create({
        trigger:'.box10',
        start:'top+=100% top+=6%',
        end:'+=60%',
        //markers:true,
        onUpdate:(self)=>{
            let index = Math.floor(self.progress * 30);
            if(index>4){
                $('.box10_right img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ng_box10_${index-4}.avif?v=1751882397`)
            }else{
                $('.box10_right img').attr('src', `https://cdn.shopify.com/s/files/1/0502/8033/3505/files/ng_box10_1.avif?v=1751882397`)
            }
            if(index>2){
                $('.box10_item2').addClass('box10_active')
                $('.box10_item1').removeClass('box10_active')
            }else{
                $('.box10_item1').addClass('box10_active')
                $('.box10_item2').removeClass('box10_active')
            }
            if(!wFlag){
                if(index>2){
                    $('.box10_item2').css({opacity:1})
                }else{
                    $('.box10_item2').css({opacity:0})
                }
            }
        }
    })
    
    ScrollTrigger.create({
        trigger:'.box10',
        start:'top top+=6%',
        end:'+=180%',
        pin:true,
    })

    showUp('.box11_title')

    if(wFlag){
        new Swiper('.box11Swiper', {
            autoplay: true,
            slidesPerView: 3,
            centeredSlides: true,
            loop:true
        })
    }

    //box9_1
    new Swiper('.box9_1Swiper', {
        autoplay: {
            delay: wFlag?2000:1500,
            disableOnInteraction: false,
        },
        slideToClickedSlide: true,
        centeredSlides: true,
        slidesPerView:wFlag?5:1.5,
        loop:true
    })

    //boxSpecs_btn
    $('.bs_btn').click(function(){
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_buy').click(function(){ 
        window.open('https://store.oxva.com/products/nexlim-go'); 
    })

    $('.pnr_spec').click(function(){
        $('.Mpn_popup').css({height:'0'})
        buyFlag = true
        $('.classic_section1').hide()
        $('.classic_section2').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
    })

    $('.pnr_over2').click(function(){
        $('.Mpn_popup').css({height:'0'})
        buyFlag = true
        $('.classic_section2').hide()
        $('.classic_section1').show()
        window.scrollTo(0,0)
        $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
        $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
    })

})